import React from 'react'
import Spinner from 'react-components/Components/Spinner'
import { useTranslation } from 'utils/useTranslation'

export function FilterDropdownBtn({ productCount, onViewProductsClick }) {
  const accessoryStrings = useTranslation('accessories_shop.misc') ?? {}
  const text = productCount != null ? accessoryStrings.show_amount_products.replace('%s', productCount) : null

  return (
    <div className='mtt-filter__dropdown-button' onClick={onViewProductsClick}>
      {productCount == null ? <Spinner /> : <span>{text}</span>}
    </div>
  )
}
